import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GetProjectsInput, ProjectInput, ProjectResult, Result, ResultList } from 'app/models';
import { Utility } from 'app/shared';
import { plainToClassFromExist } from 'class-transformer';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  constructor(private httpClient: HttpClient) { }

  public addProject(projectInput: ProjectInput): Promise<Result> {
    return this.httpClient.post(Utility.serviceAddress + 'Project/AddProject', projectInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public editProject(id: number, projectInput: ProjectInput): Promise<Result> {
    return this.httpClient.put(Utility.serviceAddress + 'Project/EditProject?id=' + id, projectInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public deleteProject(id: number): Promise<Result> {
    return this.httpClient.delete(Utility.serviceAddress + 'Project/DeleteProject?id=' + id, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new Result(), result))
      .catch(result => plainToClassFromExist(new Result(), result.error));
  }

  public getProjects(getProjectsInput: GetProjectsInput): Promise<ResultList<ProjectResult>> {
    return this.httpClient.post(Utility.serviceAddress + 'Project/GetProjects', getProjectsInput, Utility.options('dashboardToken'))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ProjectResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ProjectResult>(), result.error));
  }

  public getProjectsWithCustomerId(customerId: number, token: string): Promise<ResultList<ProjectResult>> {
    return this.httpClient.get(Utility.serviceAddress + 'Project/GetProjectsWithCustomerId?customerId=' + customerId, Utility.options(token))
      .toPromise().then(result => plainToClassFromExist(new ResultList<ProjectResult>(), result))
      .catch(result => plainToClassFromExist(new ResultList<ProjectResult>(), result.error));
  }
}